import { z } from 'zod/v4'
import { notFound } from '@tanstack/react-router'
import type { AppAbility } from '@/lib/casl'
import type { TerminalAccountContext } from './terminals.types'

export const terminalSearchSchema = z.object({
  accountContext: z.enum(['current', 'source', 'target']).optional(),
  sourceReaderId: z
    .string()
    .regex(/^tmr_[a-zA-Z0-9]+$/)
    .optional(),
})

export function assertTerminalAccountAccess(
  ability: AppAbility,
  accountContext: TerminalAccountContext | undefined
) {
  if (
    accountContext &&
    accountContext !== 'current' &&
    (!ability.can('access', 'global') || !ability.can('manage', 'stripe-migrations'))
  ) {
    throw notFound()
  }
}
